if (!customElements.get("bracelet-size-selector")) {
  customElements.define(
    "bracelet-size-selector",
    class BraceletSizeSelector extends HTMLElement {
      connectedCallback() {
        this.currentVariant = this.dataset.currentVariant;
        this.form = document.querySelector(
          `form[data-type=add-to-cart-form]:has(input[name='id'][value='${this.currentVariant}'])`,
        );
        this.errorEl = this.querySelector(".wt-bracelet-size__error");

        if (!this.form) return;

        this._onSubmit = this._onSubmit.bind(this);
        // Use capture phase so validation runs before product-form.js handler
        this.form.addEventListener("submit", this._onSubmit, true);
      }

      disconnectedCallback() {
        this.form?.removeEventListener("submit", this._onSubmit, true);
      }

      _onSubmit(evt) {
        const input = this.form.querySelector(
          'input[name="properties[Bracelet Size]"]',
        );
        if (!input || !input.value.trim()) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          if (this.errorEl) this.errorEl.removeAttribute("hidden");
          this.querySelector(".wt-select__trigger")?.focus();
        } else {
          if (this.errorEl) this.errorEl.setAttribute("hidden", "");
        }
      }
    },
  );
}
